import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { apiError } from '../../lib/adminApi';
import { Zap, Loader2 } from 'lucide-react';

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <Zap className="text-red-500" size={26} fill="currentColor" />
          <span className="text-white font-black text-2xl tracking-tight">S-MAN <span className="text-red-500">ADMIN</span></span>
        </div>
        <form onSubmit={submit} className="bg-[#0d0d0d] border border-white/10 rounded-2xl p-8 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50">Email</label>
            <input
              data-testid="login-email-input"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-black border border-white/15 rounded-lg px-4 py-3 text-white focus:border-red-500 outline-none"
              placeholder="admin@the-sman.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50">Password</label>
            <input
              data-testid="login-password-input"
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-black border border-white/15 rounded-lg px-4 py-3 text-white focus:border-red-500 outline-none"
              placeholder="••••••••"
            />
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
          <button
            data-testid="login-submit-button"
            type="submit" disabled={loading}
            className="w-full bg-red-600 hover:bg-red-500 transition-colors text-white font-bold py-3 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading && <Loader2 className="animate-spin" size={18} />}
            ACCEDI
          </button>
        </form>
      </div>
    </div>
  );
}
